import { Alert, Button, Modal, Tooltip } from "antd";
import NoData from "../shared/noDataComponent";
import { useCallback, useEffect, useState } from "react";
import Loader from "../loader.component";
import apiCalls from "src/api/apiCalls";
import { NumericFormat } from "react-number-format";
const ProgramsList = ({ open, closeModel, kpiData }) => {
    const [loader, setLoader] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const [isPrefix, setIsPrefix] = useState(false)
    const [data, setData] = useState([])
    useEffect(() => {
        getProgramsData()
    }, [])
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    const getProgramsData = async () => {
        setLoader(true);
        try {
            let response;
            if (kpiData?.name === "Cards Balance") {
                response = await apiCalls.getCardBalances(kpiData?.currency);
                setIsPrefix(true);
            } else {
                response = await apiCalls.getMerchantBalances();
                setIsPrefix(false);
            }
            if (response?.ok) {
                setData(response.data);
                setErrorMessage(null);
            } else {
                setErrorMessage(apiCalls.isErrorDispaly(response));
            }
        } catch (error) {
            setErrorMessage(error.message);
        } finally {
            setLoader(false);
        }
    };
    const getPrefix = useCallback((item) => {
        return isPrefix && item ? `${item} ` : "";
    }, [isPrefix])
    const getSuffix = useCallback((item) => {
        return !isPrefix && item ? `  ${item}` : "";
    }, [isPrefix])
    return (
        <Modal
            open={open}
            onCancel={closeModel}
            title={kpiData?.name + "s"}
            maskClosable={false}
            closeIcon={
                <Tooltip title="Close">
                    <span className="icon close c-pointer" />
                </Tooltip>
            }
            footer={<Button
                type="primary"
                className="cancel-btn"
                onClick={closeModel}
            >
                Close
            </Button>
            }>
            {loader && <div className="text-center"><Loader /></div>}

            {!loader &&
                <div>
                    {errorMessage !== null && (
                        <Alert
                            className='mb-6'
                            type="error"
                            description={errorMessage}
                            onClose={closeError}
                            showIcon
                            closable
                        />
                    )}
                    {data?.map((item) => (
                        <div class="py-2" key={item?.programName}>
                            <div class="flex justify-between items-center">
                                <p class="text-paraColor text-base font-normal">{item?.programName}</p>
                                <p class="text-subTextColor font-medium">
                                    <NumericFormat
                                        value={item?.balance}
                                        displayType="text"
                                        prefix={getPrefix(item?.symbol)}
                                        suffix={getSuffix(item?.currency)}
                                        thousandSeparator
                                        decimalScale={kpiData?.name === "Cards Balance" ? 2 : 4}
                                        className="text-lg text-subTextColor font-semibold"
                                    /></p>
                            </div>
                        </div>
                    ))}
                    {data.length > 0 && <div className="py-2 mt-4 border-t">
                        <div className="flex justify-between items-center">
                            <p className="text-paraColor text-base font-semibold">Total</p>
                            <p className="text-subTextColor font-semibold text-lg">
                                <NumericFormat
                                    value={kpiData?.balance}
                                    displayType="text"
                                    prefix={getPrefix(kpiData?.symbol)}
                                    suffix={getSuffix(kpiData?.currency)}
                                    thousandSeparator
                                    decimalScale={kpiData?.name === "Cards Balance" ? 2 : 4}
                                    className="text-lg text-subTextColor font-semibold"
                                />
                            </p>
                        </div>
                    </div>}
                    {data.length == 0 && <div className="wallet-nodata">
                        <NoData text={"No data"} />
                    </div>}
                </div>}
        </Modal>
    )
}
export default ProgramsList;